import { SaveAttributeFlow, type SaveAttributeBatchResult } from '@/features/workspace-settings'

function valuesOrNull(values: readonly string[]): string[] | null {
  const normalized = values.map((value) => value.trim()).filter(Boolean)
  return normalized.length > 0 ? normalized : null
}

export class SaveSourceMediumFlow {
  constructor(private readonly attributes = new SaveAttributeFlow()) {}

  async save(
    platform: string,
    sources: readonly string[],
    mediums: readonly string[],
    ids: { source: number | null; medium: number | null },
  ): Promise<SaveAttributeBatchResult> {
    const sourceKey: `${string}_utm_sources` = `${platform}_utm_sources`
    const mediumKey: `${string}_utm_mediums` = `${platform}_utm_mediums`

    return this.attributes.saveBatch([
      { key: sourceKey, value: valuesOrNull(sources), attributeId: ids.source },
      { key: mediumKey, value: valuesOrNull(mediums), attributeId: ids.medium },
    ])
  }
}
